import { FC } from 'react'
import { Row, Col, Text, Button, Icon } from '@/client/components'
import { useRouterPush } from '@/client/hooks'
import * as S from './styles'
import { FinishingSetProps } from './types'

export const FinishingSheet: FC<FinishingSetProps> = ({ finishing_techniques_title = '', finishing }) => (
  <S.TileBlockWrapper>
    <div className='tileblock-full'>
      <Row>
        <Col xs='12' xl='12'>
          <Text as='h1' size='h5max' family='text' weight='semiBlack' margin='0 0 1.5rem' itemProp='name'>
            {finishing_techniques_title}
          </Text>
        </Col>
      </Row>
      <S.FBBlocks>
        <Row>
          {finishing &&
            finishing.length > 0 &&
            finishing.map((property, index) => (
              <Col
                xs='12'
                xl='6'
                xl2='6'
                xl4='3'
                className='fb-block'
                noGutter
                key={`${property['blocktitle']}-${index}`}
              >
                <S.FBHead>
                  <Col>
                    <Text as='h6' size='lg' family='text' weight='semiBlack' margin='0 0 1rem'>
                      {property['blocktitle']}
                    </Text>
                    <span className='block-p' dangerouslySetInnerHTML={{ __html: property['blockdesc'] }}></span>
                  </Col>
                </S.FBHead>
                <S.FBBody>
                  <Col>
                    <S.FBIconSet>
                      {property['finishingprops'].map((eachProp, iconIndex) => (
                        <S.FBIconRow key={`${eachProp['propicon']}-${iconIndex}`}>
                          <S.IconBox>
                            {(() => {
                              switch (eachProp['propicon']) {
                                case 'ellipse-small':
                                  return <Icon name={'ellipse-small'} className='FBIcon'></Icon>
                                case 'line-vetical':
                                  return <Icon name={'line-vetical'} className='FBIcon'></Icon>
                                case 'pointer-scissor':
                                  return <Icon name={'pointer-scissor'} className='FBIcon'></Icon>
                                default:
                                  return <Icon name={'ellipse-small'} className='FBIcon'></Icon>
                              }
                            })()}
                          </S.IconBox>
                          <span className='block-p' dangerouslySetInnerHTML={{ __html: eachProp['proptitle'] }}></span>
                        </S.FBIconRow>
                      ))}
                    </S.FBIconSet>
                    <div
                      className='fb-note block-p'
                      dangerouslySetInnerHTML={{
                        __html: property['note']
                      }}
                    ></div>
                  </Col>
                </S.FBBody>
              </Col>
            ))}
        </Row>
      </S.FBBlocks>
    </div>
  </S.TileBlockWrapper>
)
